var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFoldAllIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.72222 0H0.277778C0.124365 0 0 0.124365 0 0.277778V0.347222C0 0.500635 0.124365 0.625 0.277778 0.625H9.72222C9.87564 0.625 10 0.500635 10 0.347222V0.277778C10 0.124365 9.87564 0 9.72222 0Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72222 9.375H0.277778C0.124365 9.375 0 9.49937 0 9.65278V9.72222C0 9.87563 0.124365 10 0.277778 10H9.72222C9.87564 10 10 9.87563 10 9.72222V9.65278C10 9.49937 9.87564 9.375 9.72222 9.375Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0189 4.5L2.74858 2.22968C2.65737 2.13847 2.65737 1.99026 2.74858 1.89904L3.07922 1.56841C3.17043 1.4772 3.31865 1.4772 3.40986 1.56841L5.01861 3.17716L6.62736 1.56841C6.71857 1.4772 6.86679 1.4772 6.958 1.56841L7.28863 1.89904C7.37984 1.99026 7.37984 2.13847 7.28863 2.22968L5.01832 4.5H5.0189Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62712 8.24409L5.01836 6.63534L3.40961 8.24409C3.3184 8.3353 3.17019 8.3353 3.07898 8.24409L2.74834 7.91346C2.65713 7.82224 2.65713 7.67403 2.74834 7.58282L5.01866 5.3125L7.28897 7.58282C7.38018 7.67403 7.38018 7.82224 7.28897 7.91346L6.95834 8.24409C6.86713 8.3353 6.71833 8.3353 6.62712 8.24409Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoldAllIcon);
export default __webpack_public_path__ + "static/media/FoldAllIcon.243bf0052fd80ecc495377576a6ef704.svg";
export { ForwardRef as ReactComponent };